import React from "react";

const AuthenticationError = (props) => {
  return (
    <>
      <div className="home max-w-full">
        <span>
          <h4 className="flex justify-center items-center h-[20rem]">
            <p className="font-sans font-semibold">
              You don't have enough privileges to access the page, Kindly
              contact your admin.
            </p>
          </h4>
        </span>
      </div>
    </>
  );
};

export default AuthenticationError;
